import { mapState } from "vuex";
export const payManageIndexMixins = {
  computed: {
    payManageTopBarList() {
      let topbarList = [
        {
          name: "缴费机构管理",
          isActive: false,
          path: "/paymanage",
          icon:require("@/assets/img/menuIcons/icon-paymanage.png")
        },
        {
          name: "缴费项目管理",
          isActive: false,
          path: "/paymanage/project",
          icon:require("@/assets/img/menuIcons/icon-paymanageproject.png")
        },
        {
          name: "缴费账单管理",
          isActive: false,
          path: "/paymanage/bill",
          icon:require("@/assets/img/menuIcons/icon-paymanagebill.png")
        },
      ];
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
      });
      return topbarList;
    },
  },
}
